import Vue from 'vue';
import App from './App.vue';
import router from '@/admin-router';
import store from '@/store';
import { createProvider } from '@/vue-apollo';

import '@/assets/sass/main.scss';
import './registerServiceWorker';

Vue.config.productionTip = false;

store.commit('setAdminMode', true);

new Vue({
  router,
  store,
  provide: createProvider().provide(),
  render: (h) => h(App),
}).$mount('#app');
